import * as Preact from "preact"
import PolygonClipping from "polygon-clipping"

import App from "@frog/source/models/App.js"
import Zone from "@frog/source/models/Zone.js"

import Dev from "@frog/source/models/admin/Dev.js"

import units from "@frog/source/data/units.js"
import unitTemplates from "@frog/source/data/unitTemplates.js"
import elements from "@frog/source/data/elements.js"

import Director from "@frog/source/juice/Director.js"
import Geometry from "@frog/source/utility/Geometry.js"
import Loop from "@frog/source/utility/Loop.js"
import Random from "@frog/source/utility/Random.js"
Math.clamp = function(min = 0, max = 1, value) {
    return Math.max(min, Math.min(max, value))
}

import UnitSprite from "@frog/source/views/components/UnitSprite.jsx"
import UnitTemplateSprite from "@frog/source/views/components/UnitTemplateSprite.jsx"
import UnitHealthBar from "@frog/source/views/components/UnitHealthBar.jsx"
import "@frog/source/views/Stage.less"

import Preload from "@frog/source/utility/Preload.js"

export default class Stage {
    render() {
        return (
            <div class="Stage"
                onMouseDown={this.onMouseDown}
                onMouseUp={this.onMouseUp}
                onContextMenu={this.onContextMenu}>
                <Camera stage={this.props.stage}>
                    <WorldImage stage={this.props.stage}/>
                    <Darkness stage={this.props.stage}/>
                    <Units stage={this.props.stage}/>
                    <ActionRange stage={this.props.stage}/>
                    <ActionArrow stage={this.props.stage}/>
                    <Cursor stage={this.props.stage}/>
                    <Squiggles/>
                </Camera>
            </div>
        )
    }
}

function Squiggles() {
    return (
        <svg display="none">
            <defs>
                <filter id="squiggly-0">
                    <feTurbulence id="turbulence" baseFrequency="0.02" numOctaves="3" result="noise" seed="0"/>
                    <feDisplacementMap in="SourceGraphic" in2="noise" scale="2" />
                </filter>
                <filter id="squiggly-1">
                    <feTurbulence id="turbulence" baseFrequency="0.02" numOctaves="3" result="noise" seed="1"/>
                    <feDisplacementMap in="SourceGraphic" in2="noise" scale="3" />
                </filter>
                <filter id="squiggly-2">
                    <feTurbulence id="turbulence" baseFrequency="0.02" numOctaves="3" result="noise" seed="2"/>
                    <feDisplacementMap in="SourceGraphic" in2="noise" scale="2" />
                </filter>
                <filter id="squiggly-3">
                    <feTurbulence id="turbulence" baseFrequency="0.02" numOctaves="3" result="noise" seed="3"/>
                    <feDisplacementMap in="SourceGraphic" in2="noise" scale="3" />
                </filter>
                <filter id="squiggly-4">
                    <feTurbulence id="turbulence" baseFrequency="0.02" numOctaves="3" result="noise" seed="4"/>
                    <feDisplacementMap in="SourceGraphic" in2="noise" scale="1" />
                </filter>
            </defs>
        </svg>
    )
}

let flickering = 0.5
function Darkness({stage}) {
    if(stage.world == undefined) return
    if(stage.currentEncounter == undefined) return

    let points = [
        "0em 0em",
        "0em " + stage.world.height + "em",
        stage.world.width + "em" + " " + stage.world.height + "em",
        stage.world.width + "em" + " " + "0em",
    ]

    // const zone = stage.world.zones[stage.currentEncounter || "1"]

    if(App.game.configuration.darkness == "none") {
        return
    }

    let polygons = []
    if(App.game.configuration.darkness == false) {
        const zone = stage.world.zones[stage.currentEncounter]
        if(zone.points != undefined) {
            polygons.push([
                ...zone.points,
                zone.points[0]
            ])
        } else {
            const x1 = zone.x
            const y1 = zone.y
            const x2 = zone.x + zone.width
            const y2 = zone.y + zone.height
            polygons.push([
                {"x": x1, "y": y1},
                {"x": x2, "y": y1},
                {"x": x2, "y": y2},
                {"x": x1, "y": y2},
                {"x": x1, "y": y1},
            ])
        }
    }

    if(App.game.configuration.darkness == true
    || App.game.configuration.darkness == "night") {
        flickering = Math.clamp(-0.25, 0.25, flickering + Random.range(-0.05, 0.05))
        const flux = 1 + flickering

        Object.values(stage.encounters).map((encounter) => {
            const zone = encounter.zone
            // if(parseInt(zone.slug) > parseInt(stage.currentEncounter)) return
            if(encounter.slug != stage.currentEncounter
            && encounter.hasBeenSeen != true) {
                return
            }
            if(zone.points != undefined) {
                polygons.push([
                    ...zone.points,
                    zone.points[0]
                ].map((point, index) => {
                    const vector = Geometry.multiply(point.internalAngle, flux)
                    return Geometry.add(point, vector)
                }))
            } else {
                const x1 = zone.x - flux
                const y1 = zone.y - flux
                const x2 = zone.x + zone.width + flux
                const y2 = zone.y + zone.height + flux
                polygons.push([
                    {"x": x1, "y": y1},
                    {"x": x2, "y": y1},
                    {"x": x2, "y": y2},
                    {"x": x1, "y": y2},
                    {"x": x1, "y": y1},
                ])
            }
        })

        if(polygons.length == 0) return

        polygons = PolygonClipping.union(
            ...polygons.map((polygon) => {
                const array = polygon.map((point) => {
                    return [point.x, point.y]
                })
                return [array]
            })
        ).map((polygon) => {
            polygon = polygon[0]
            return polygon.map((point) => {
                return {"x": point[0], "y": point[1]}
            })
        })
    }

    polygons.forEach((polygon) => {
        polygon.unshift({"x": 0, "y": 0})
    })
    polygons = polygons.map((polygon) => {
        return polygon.map((point) => emify(point))
    })
    polygons.forEach((polygon) => {
        points = points.concat(polygon)
    })

    return (
        <div class="Darkness" style={{
            "width": stage.world.width + "em",
            "height": stage.world.height + "em",
            "clip-path": "polygon(" + points.join(", ") + ")",
            "opacity": App.game.configuration.darkness ? (App.game.configuration.darkness == "night" ? 0.5 : 1) : 0.5,
        }}/>
    )
}
function emify(point) {
    return point.x + "em" + " " + point.y + "em"
}

class Camera {
    render() {
        return (
            <div class="Camera" style={this.style}>
                {this.props.children}
            </div>
        )
    }
    get style() {
        return {
            "left": -1 * App.game.chapter.selection.camera.position.x + "em",
            "top": -1 * App.game.chapter.selection.camera.position.y + "em",
            "font-size": (1 / (App.game.chapter.selection.camera.position.z ?? 1)) + "em",
        }
    }
}

class ActionArrow {
    render() {
        if(Dev.inProtoMode) return

        const action = App.game.chapter.selection.hoveredAction
        if(action == undefined) return

        if(action.type == "invoke skill") {
            const previousPosition = action.positions[1]
            const direction = Geometry.direction(action.positions[0], action.positions[1])
            const position = Geometry.add(action.positions[1], Geometry.multiply(direction, 0.5))

            return (
                <div class="AttackArrow" role={action.role} style={{
                    "top": position.y + "em",
                    "left": position.x + "em",
                }}/>
            )
        }

        // return (
        //     <svg class="ActionArrow" viewBox="0 0 16 9">
        //         <polyline points={this.points}/>
        //     </svg>
        // )
    }
    get points() {
        const action = App.game.chapter.selection.hoveredAction
        const movementPositions = action.positions.filter((position) => {
            return position.type == "wait"
                || position.type == "move"
                || position.type == "move through"
        })

        // const action = {"positions": [{"x": 0, "y": 0}, {"x": 5, "y": 3}]}
        return movementPositions.map((position) => {
            return ((position.x + 0.5) * 10) + "," + ((position.y + 0.6) * 10)
        }).join(" ")
    }
}
function getAngleBetweenPoints(p1, p2) {
    return Math.atan2(p2.y - p1.y, p2.x - p1.x) * 180 / Math.PI
}

class Cursor {
    render() {
        const stage = this.props.stage
        if(stage == undefined) return
        if(stage.dialogue != undefined) return
        // if(App.game.chapter.selection.position.z == 0) {
        //     return
        // }
        if(World.isOutOfBounds(stage.world, App.game.chapter.selection.position)) {
            return
        }

        if(Dev.inProtoMode == false
        && Zone.isInBounds(stage.encounters[stage.currentEncounter || 1].zone, App.game.chapter.selection.position) == false) {
            return
        }

        if(World.isEmptyPosition(stage.world, App.game.chapter.selection.position)) {
            return
        }

        if(Dev.selectedTemplate != undefined) {
            return (
                <div class="Cursor" style={this.style}>
                    <div class="Sprite" isHovered={this.isHovered}/>
                    <UnitTemplateSprite unitTemplate={Dev.selectedTemplate}/>
                </div>
            )
        }


        return (
            <div class="Cursor" style={this.style}>
                <div class="Sprite" isHovered={this.isHovered}/>
            </div>
        )
    }
    get isHovered() {
        return App.game.chapter.selection.hoveredUnitKey != undefined
    }
    get style() {
        const selection = App.game.chapter.selection

        return {
            "left": selection.position.x + "em",
            "top": selection.position.y + "em",
        }
    }
}

class WorldImage {
    render() {
        return (
            <div class="WorldImage" style={{
                "background-image": "url(" + this.props.stage.image + ")",
                "width": this.props.stage.world.width + "em",
                "height": this.props.stage.world.height + "em",
            }}/>
        )
    }
}

class WorldBlocks {
    render() {
        const blocks = Object.values(this.props.stage.world.blocks || []).map((block) => {
            if(block.image == undefined) return
            if(Zone.isInBounds(App.game.chapter.selection.camera.renderzone, block.position) == false) {
                return
            }
            return (
                <WorldBlock block={block}/>
            )
        })
        return blocks
    }
}

class WorldBlock {
    render() {
        return (
            <div class="WorldBlock" style={this.style}/>
        )
    }
    get style() {
        return {
            "left": this.props.block.position.x + "em",
            "top": this.props.block.position.y + "em",
            "background-image": "url(" + this.props.block.image + ")",
        }
    }
}

class Units {
    render() {
        const stage = this.props.stage
        return Object.values(stage.units).map((unit, index) => {
            if(unit == undefined) return
            if(unit.isDead == true) return
            if(unit.hasBeenRemoved == true) return
            if(unit.isNotRendered) return

            const roundedPosition = {
                "x": Math.round(unit.position.x),
                "y": Math.round(unit.position.y)
            }
            if(stage.currentEncounter != undefined && Zone.isInBounds(stage.encounters[stage.currentEncounter].zone, roundedPosition) == false) return

            let omegaunit = undefined
            if(Director.isPerforming != true
            && App.game.chapter?.selection?.hoveredAction?.omegastage?.units[unit.key] != undefined) {
                omegaunit = App.game.chapter.selection.hoveredAction.omegastage.units[unit.key]
            }

            return <Unit stage={stage} unit={unit} omegaunit={omegaunit}/>
        })
    }
}

class Unit {
    render() {
        if(this.props.unit.type == "zone" && Dev.inProtoMode == false) return
        return (
            <div class="Unit" style={this.style} key={this.props.unit.key}>
                <UnitSprite unit={this.props.unit} isGrayscaled={this.isDone}/>
                <UnitHealthBar stage={this.props.stage} unit={this.props.unit} omegaunit={this.props.omegaunit}/>
                <div class="UnitElement" element={this.props.unit.element} style={{
                    "background-color": elements[this.props.unit.element]?.color
                }}/>
                <div class="Selection" isHovered={this.isHovered} isSelected={this.isSelected}/>
            </div>
        )
    }
    get style() {
        return {
            "left": this.props.unit.position.x + "em",
            "top": this.props.unit.position.y + "em",
            "opacity": this.props.unit.opacity, // for death
        }
    }
    get isDone() {
        if(this.props.unit.affiliation == "bad") return false
        if(this.props.unit.energy == undefined) return false
        return this.props.unit.energy["move"] === false
            && this.props.unit.energy["invoke skill"] === false
    }
    get isHovered() {
        if(Dev.inProtoMode == false) return false
        return this.props.unit.key == App.game.chapter?.selection?.hoveredUnitKey
    }
    get isSelected() {
        if(Dev.inProtoMode == false) return false
        if(this.props.unit.key == App.game.chapter?.selection?.selectedUnitKey) return true
        if(App.game.chapter?.selection?.multiselectedUnitKeys.has(this.props.unit.key)) return true
        return false
    }
}

class ActionRange {
    render() {
        if(App.game.chapter.phase != "play") return
        // if(App.game.chapter.sequence != undefined
        // || App.game.chapter.sequence?.steps?.length > 0) {
        //     return
        // }

        if(App.game.chapter.selection.selectedUnitKey != undefined) {
            return (
                <UnitActionRange stage={this.props.stage}
                    unit={this.props.stage.units[App.game.chapter.selection.selectedUnitKey]}/>
            )
        }

        if(App.game.chapter.selection.hoveredUnitKey != undefined) {
            return (
                <UnitActionRange stage={this.props.stage}
                    unit={this.props.stage.units[App.game.chapter.selection.hoveredUnitKey]}/>
            )
        }
    }
}

class UnitActionRange {
    render() {
        const unit = this.props.unit
        const stage = this.props.stage

        if(unit == undefined) return
        if(unit.isDead == true) return

        let actionmap = unit.actionmap
        if(stage.nextTurn != undefined
        && stage.nextTurn.aiActions != undefined
        && stage.nextTurn.aiActions[unit.key] != undefined
        && stage.nextTurn.aiActions[unit.key].actionmap != undefined) {
            actionmap = stage.nextTurn.aiActions[unit.key].actionmap
        }
        if(actionmap == undefined) return

        return Object.values(actionmap).map((actionlist, positionKey) => {
            const action = App.game.chapter.selection.findActionInActionlist({unit, actionlist})
            if(action == undefined) return
            return <UnitActionRangeTile stage={this.props.stage} unit={this.props.unit} action={action}/>
        })
    }
}

import World from "@frog/source/models/World.js"
class UnitActionRangeTile {
    render() {
        return (
            <div class="UnitActionRangeTile" style={this.style}>
                <div class="Sprite" type={this.type}/>
            </div>
        )
    }
    get style() {
        const terrain = World.getTerrain(this.props.stage.world, this.props.action.position)
        if(terrain == undefined) return

        return {
            "left": terrain.position.x + "em",
            "top": terrain.position.y + "em",
            "opacity": App.game.chapter.selection.selectedUnitKey == this.props.unit.key ? 0.75 : 0.5,
        }
    }
    get type() {
        if(this.props.stage.units[this.props.action.performerKey].affiliation == "bad") {
            return "enemy action"
        }
        if(this.props.action.type == "invoke skill"
        && this.props.action.role == "support") {
            return "support action"
        }
        return this.props.action.type
    }
}
